import React from 'react'


function ServiceDetails() {
  return (
    <>
        {/* <div className="dlplatforms-wrap">
          <AnimateLine/>
          <Breadcrumb pageName="Service Details" pageTitle="Service Details"/>
          <ServiceDetailsWrap/>
          <SubscribArea/>
        </div> */}
    </>
  )
}

export default ServiceDetails